// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3EcVe","requiredAsterisk":"Info_requiredAsterisk__3umw8"};